
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

var files = {};
var $lang = {};
const langDir = require.context('../../lang', true, /\.js$/);
langDir.keys().forEach(function(d){
  files[d] = langDir(d);
});
const lang = !localStorage.getItem("locale") ? "en" : localStorage.getItem("locale");

for(var i in files){
  if(i.indexOf('./'+lang+'/') === 0){
    var lang_name = i.replace('./'+lang+'/', '').replace('.js', '');
    $lang[lang_name] = files[i];
  }
}

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      redirect: '/login'
    },
    {
      path: '/',
      component: () => import('@/views/Main'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'sales-summary',

          component: () => import('@/views/reports/SalesSummary'),
          meta: {
            title: 'sales_summary',
            breadcrumb: [{ name: 'reports' },
            { name: 'sales_summary' }
            ]
          },
        },
        {
          path: 'sales-by-item',
          component: () => import('@/views/reports/Item'),
          meta: {
            title: 'sales_by_item',
            breadcrumb: [{ name: 'reports' },
            { name: 'sales_by_item' }
            ]
          },
        },
        {
          path: 'customers',
          component: () => import('@/views/customers/customers'),
          meta: {
            title: 'customers',
            breadcrumb: [{ name: 'customers' },

            ]
          },
        },
        {
          path: 'audit-log',
          component: () => import('@/views/auditLog/AuditLog'),
          meta: {
            title: 'audit_log',
            breadcrumb: [{ name: 'audit_log' },
            ]
          },
        },
        {
          path: 'business-resource',
          component: () => import('@/views/businessResource/businessResource'),
          meta: {
            title: 'business_resources',
            breadcrumb: [{ name: 'business_resources' },
            ]
          },
        },
        {
          path: 'review',
          component: () => import('@/views/review/review'),
          meta: {
            title: 'review',
            breadcrumb: [{ name: 'review' },

            ]
          },
        },
        {
          path: 'settings',
          component: () => import('@/views/settings/Settings'),
          meta: {
            title: 'settings',
            breadcrumb: [{ name: 'settings' }]
          },
        },
        {
          path: 'settings/:slug',
          component: () => import('@/views/settings/Settings'),
          name: 'SettingTab',
          meta: {
            title: 'settings',
            breadcrumb: [{ name: 'settings' }]
          }
        },

        {
          path: 'profile',

          component: () => import('@/views/profile/profile'),
          meta: {
            title: 'profile',
            breadcrumb: [{ name: 'profile' },
            ]
          },
        },
        {
          path: 'add-store',
          component: () => import('@/views/settings/AddStore'),
          meta: {
            title: 'add_store',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'add_store' }
            ]
          },

        },
        {
          path: 'edit-store/:id',
          component: () => import('@/views/settings/AddStore'),
          meta: {
            title: 'edit_store',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'edit_store' }
            ]
          },
        },
        {
          path: 'add-pos',
          component: () => import('@/views/settings/AddPOS'),
          meta: {
            title: 'add_pos',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'add_pos' }
            ]
          },
        },
        {
          path: 'edit-pos/:id',
          component: () => import('@/views/settings/AddPOS'),
          meta: {
            title: 'edit_pos',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'edit_pos' }
            ]
          },
        },
        {
          path: 'add-sobat-category',
          component: () => import('@/views/settings/AddSobatCategory'),
          meta: {
            title: 'add_sobat_category',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'add_sobat_category' }
            ]
          },
        },
        {
          path: 'edit-sobat-category/:id',
          component: () => import('@/views/settings/AddSobatCategory'),
          meta: {
            title: 'edit_sobat_category',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'edit_sobat_category' }
            ]
          },
        },
        {
          path: 'add-menu',
          component: () => import('@/views/settings/AddMenu'),
          meta: {
            title: 'add_menu',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'add_menu' }
            ]
          },
        },
        {
          path: 'edit-menu/:id',
          component: () => import('@/views/settings/AddMenu'),
          meta: {
            title: 'edit_menu',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'edit_menu' }
            ]
          },
        },
        {
          path: 'add-dinning-option',
          component: () => import('@/views/settings/AddDinningOption'),
          meta: {
            title: 'add_dinning_option',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'add_dinning_option' }
            ]
          },
        },
        {
          path: 'edit-dinning-option/:id',
          component: () => import('@/views/settings/AddDinningOption'),
          meta: {
            title: 'edit_dinning_option',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'edit_dinning_option' }
            ]
          },
        },
        {
          path: 'employees',
          component: () => import('@/views/employees/Employees'),
          meta: {
            title: 'employees',
            breadcrumb: [{ name: 'employees' },

            ]
          },
        },
        {
          path: 'access-rights',
          component: () => import('@/views/employees/AccessRight'),
          meta: {
            title: 'access_rights',
            breadcrumb: [{ name: 'employees', link: "/employees" },
            { name: 'access_rights', },
            ]
          },
        },
        {
          path: 'add-access-rights',
          component: () => import('@/views/employees/AddAccessRight'),
          meta: {
            title: 'add_role',
            breadcrumb: [{ name: 'employees', link: "/employees" },
            { name: 'access_rights', link: "/access-rights" },
            { name: 'add_role' },
            ]
          },
        },
        {
          path: 'edit-access-rights/:id',
          component: () => import('@/views/employees/AddAccessRight'),
          meta: {
            title: 'edit_role',
            breadcrumb: [{ name: 'employees', link: "/employees" },
            { name: 'access_rights', link: "/access-rights" },
            { name: 'edit_role' },
            ]
          },
        },
        {
          path: 'time-card',
          component: () => import('@/views/employees/TimeCard'),
          meta: {
            title: 'time_card',
            breadcrumb: [{ name: 'employees', link: "/employees" },
            { name: 'time_card' },
            ]
          },
        },
        {
          path: 'add-time-card',
          component: () => import('@/views/employees/AddTimeCard'),
          meta: {
            title: 'add_time_card',
            breadcrumb: [{ name: 'employees', link: "/employees" },
            { name: 'time_card', link: "/time-card" },
            { name: 'add_time_card' },
            ]
          },
        },
        {
          path: 'edit-time-card/:id',
          component: () => import('@/views/employees/AddTimeCard'),
          meta: {
            title: 'edit_time_card',
            breadcrumb: [{ name: 'employees', link: "/employees" },
            { name: 'time_card', link: "/time-card" },
            { name: 'edit_time_card' },
            ]
          },
        },
        {
          path: 'total-hours-worked',
          component: () => import('@/views/employees/TotalHoursWorked'),
          meta: {
            title: 'total_hours_worked',
            breadcrumb: [{ name: 'employees', link: "/employees" },
            { name: 'total_hours_worked' },
            ]
          },
        },
        {
          path: 'category',
          component: () => import('@/views/item/Category'),
          meta: {
            title: 'category',
            breadcrumb: [{ name: 'category' },

            ]
          },
        },
        {
          path: 'add-kitchen-printer',
          component: () => import('@/views/settings/AddKitchenPrinter'),
          meta: {
            title: 'add_kitchen_printer',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'add_kitchen_printer' }
            ]
          },
        },
        {
          path: 'edit-kitchen-printer/:id',
          component: () => import('@/views/settings/AddKitchenPrinter'),
          meta: {
            title: 'edit_kitchen_printer',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'edit_kitchen_printer' }
            ]
          },
        },
        {
          path: 'add-tax',
          component: () => import('@/views/settings/AddTax'),
          meta: {
            title: 'add_tax',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'add_tax' }
            ]
          },
        },
        {
          path: 'edit-tax/:id',
          component: () => import('@/views/settings/AddTax'),
          meta: {
            title: 'edit_tax',
            breadcrumb: [{ name: 'settings', link: "/settings" },
            { name: 'edit_tax' }
            ]
          },
        },
        {
          path: 'discount',
          component: () => import('@/views/item/Discount'),
          meta: {
            title: 'discount',
            breadcrumb: [{ name: 'discount' },

            ]
          },
        },
        {
          path: 'modifier',
          component: () => import('@/views/item/Modifier'),
          meta: {
            title: 'modifier',
            breadcrumb: [{ name: 'modifier' },

            ]
          },
        },
        {
          path: 'add-modifier',
          component: () => import('@/views/item/AddModifier'),
          meta: {
            title: 'add_modifier',
            breadcrumb: [{ name: 'Modifier', link: "/modifier" },
            { name: 'Add Modifier' },
            ]
          },
        },
        {
          path: 'edit-modifier/:id',
          component: () => import('@/views/item/AddModifier'),
          meta: {
            title: 'edit_modifier',
            breadcrumb: [{ name: 'Modifier', link: "/modifier" },
            { name: 'Edit Modifier' },
            ]
          },
        },
        {
          path: 'items',
          component: () => import('@/views/item/Items'),
          meta: {
            title: 'items',
            breadcrumb: [{ name: 'items' }]
          },
        },
        {
          path: 'deleted-items',
          component: () => import('@/views/item/DeletedItems'),
          meta: {
            title: 'recently_deleted_items',
            breadcrumb: [{ name: 'recently_deleted_items' }]
          },

        },
        {
          path: 'add-item',
          component: () => import('@/views/item/AddItem'),
          meta: {
            title: 'add_item',
            breadcrumb: [{ name: 'items', link: "/items" },
            { name: 'add_item', link: "/add-item" },
            ]
          },
        },
        {
          path: 'edit-item/:id',
          component: () => import('@/views/item/AddItem'),
          meta: {
            title: 'edit_item',
            breadcrumb: [{ name: 'Items', link: "/items" },
            { name: 'edit_item' },
            ]
          },
        },
        {
          path: 'supplier-list',
          component: () => import('@/views/inventory/supplier'),
          meta: {
            title: 'suppliers',
            breadcrumb: [{ name: 'suppliers', link: "/supplier-list" },

            ]
          },
        },
        {
          path: 'add-supplier',
          component: () => import('@/views/inventory/SupplierView'),
          meta: {
            title: 'add_supplier',
            breadcrumb: [{ name: 'suppliers', link: "/supplier-list" },
            { name: 'add_supplier' },
            ]
          },
        },
        {
          path: 'supplier/edit/:id',
          component: () => import('@/views/inventory/SupplierView'),
          meta: {
            title: 'edit_supplier',
            breadcrumb: [{ name: 'suppliers', link: "/supplier-list" },
            { name: 'edit_supplier' },
            ]
          },
        },
        {
          path: 'purchase-order',
          component: () => import('@/views/inventory/PurchaseOrder'),
          meta: {
            title: 'purchase_order',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'purchase_order' }
            ]
          },
        },
        {
          path: 'add-purchase-order',
          component: () => import('@/views/inventory/AddPurchaseOrder'),
          meta: {
            title: 'add_purchase_order',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'add_purchase_order' }
            ]
          },
        },
        {
          path: 'edit-purchase-order/:id',
          component: () => import('@/views/inventory/AddPurchaseOrder'),
          meta: {
            title: 'edit_purchase_order',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'edit_purchase_order' }
            ]
          },
        },
        {
          path: 'view-purchase-order/:id',
          component: () => import('@/views/inventory/ViewPurchaseOrder'),
          meta: {
            title: 'purchase_order_details',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'purchase_order_details' }
            ]
          },
        },
        {
          path: 'receive-purchase-order/:id',
          component: () => import('@/views/inventory/ReceivePurchaseOrder'),
          meta: {
            title: 'receive_purchase_order',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'receive_purchase_order' }
            ]
          },
        },
        {
          path: 'transfer-orders',
          component: () => import('@/views/inventory/TransferOrder'),
          meta: {
            title: 'transfer_order',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'transfer_order' }
            ]
          },
        },

        {
          path: 'add-transfer-order',
          component: () => import('@/views/inventory/AddTransferOrder'),
          meta: {
            title: 'add_transfer_order',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'add_transfer_order' }
            ]
          },
        },

        {
          path: 'view-transfer-order/:id',
          component: () => import('@/views/inventory/ViewTransferOrder'),
          meta: {
            title: 'transfer_order_details',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'transfer_order_details' }
            ]
          },
        },

        {
          path: 'edit-transfer-order/:id',
          component: () => import('@/views/inventory/AddTransferOrder'),
          meta: {
            title: 'edit_transfer_order',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'edit_transfer_order' }
            ]
          },
        },

        {
          path: 'stock-adjustment',
          component: () => import('@/views/inventory/StockAdjustment'),
          meta: {
            title: 'stock_adjustment',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'stock_adjustment' }
            ]
          },
        },

        {
          path: 'add-stock-adjustment',
          component: () => import('@/views/inventory/AddStockAdjustment'),
          meta: {
            title: 'add_stock_adjustment',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'add_stock_adjustment' }
            ]
          },
        },

        {
          path: 'view-stock-adjustment/:id',
          component: () => import('@/views/inventory/ViewStockAdjustment'),
          meta: {
            title: 'stock_adjustment_details',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'stock_adjustment_details' }
            ]
          },
        },

        {
          path: 'edit-stock-adjustment/:id',
          component: () => import('@/views/inventory/AddStockAdjustment'),
          meta: {
            title: 'edit_stock_adjustment',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'edit_stock_adjustment' }
            ]
          },
        },

        {
          path: 'inventory-count',
          component: () => import('@/views/inventory/InventoryCounts'),
          meta: {
            title: 'inventory_counts',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'inventory_counts' }
            ]
          },
        },

        {
          path: 'add-inventory-count',
          component: () => import('@/views/inventory/AddInventoryCounts'),
          meta: {
            title: 'add_inventory_counts',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'add_inventory_counts' }
            ]
          },
        },

        {
          path: 'view-inventory-count/:id',
          component: () => import('@/views/inventory/ViewInventoryCounts'),
          meta: {
            title: 'inventory_count_details',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'inventory_count_details' }
            ]
          },
        },

        {
          path: 'edit-inventory-count/:id',
          component: () => import('@/views/inventory/AddInventoryCounts'),
          meta: {
            title: 'edit_inventory_counts',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'edit_inventory_counts' }
            ]
          },
        },

        {
          path: 'count-stock/:id',
          component: () => import('@/views/inventory/CountInventoryCounts'),
          meta: {
            title: 'count_stock',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'count_stock' }
            ]
          },
        },

        {
          path: 'production',
          component: () => import('@/views/inventory/Production'),
          meta: {
            title: 'production',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'production' }
            ]
          },
        },

        {
          path: 'add-production',
          component: () => import('@/views/inventory/AddProduction'),
          meta: {
            title: 'add_production',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'add_production' }
            ]
          },
        },

        {
          path: 'add-disassembly',
          component: () => import('@/views/inventory/AddProduction'),
          meta: {
            title: 'add_disassembly',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'add_disassembly' }
            ]
          },
        },

        {
          path: 'view-production/:id',
          component: () => import('@/views/inventory/ViewProduction'),
          meta: {
            title: 'production_details',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'production_details' }
            ]
          },
        },
        {
          path: 'view-disassembly/:id',
          component: () => import('@/views/inventory/ViewProduction'),
          meta: {
            title: 'disassembly_details',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'disassembly_details' }
            ]
          },
        },

        {
          path: 'edit-production/:id',
          component: () => import('@/views/inventory/AddProduction'),
          meta: {
            title: 'edit_production',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'edit_production' }
            ]
          },
        },

        {
          path: 'edit-disassembly/:id',
          component: () => import('@/views/inventory/AddProduction'),
          meta: {
            title: 'edit_disassembly',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'edit_disassembly' }
            ]
          },
        },

        {
          path: 'inventory-history',
          component: () => import('@/views/inventory/InventoryHistory'),
          meta: {
            title: 'inventory_history',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'inventory_history' }
            ]
          },
        },
        {
          path: 'inventory-valuation',
          component: () => import('@/views/inventory/InventoryValuation'),
          meta: {
            title: 'inventory_valuation',
            breadcrumb: [{ name: 'inventory_management' },
            { name: 'inventory_valuation' }
            ]
          },
        },
        {
          path: 'sales_shifts',
          component: () => import('@/views/reports/Shifts'),
          meta: {
            title: 'shifts',
            breadcrumb: [{ name: 'reports' },
            { name: 'shifts' }
            ]
          },
        },
        {
          path: 'sales_category',
          component: () => import('@/views/reports/Category'),
          meta: {
            title: 'sales_by_category',
            breadcrumb: [{ name: 'reports' },
            { name: 'sales_by_category' }
            ]
          },
        },
        {
          path: 'sales_employee',
          component: () => import('@/views/reports/Employee'),
          meta: {
            title: 'sales_by_employee',
            breadcrumb: [{ name: 'reports' },
            { name: 'sales_by_employee' }
            ]
          },
        },
        {
          path: 'sales_payment',
          component: () => import('@/views/reports/Payment'),
          meta: {
            title: 'sales_by_payment_type',
            breadcrumb: [{ name: 'reports' },
            { name: 'sales_by_payment_type' }
            ]
          },
        },
        {
          path: 'sales_receipts',
          component: () => import('@/views/reports/Receipt'),
          meta: {
            title: 'receipts',
            breadcrumb: [{ name: 'reports' },
            { name: 'receipts' }
            ]
          },
        },
        {
          path: 'rating',
          component: () => import('@/views/reports/Rating'),
          meta: {
            title: 'review_rating',
            breadcrumb: [{ name: 'reports' },
            { name: 'review_rating' },
            ]
          },
        },
        {
          path: 'sales-by-modifier',
          component: () => import('@/views/reports/Modifier'),
          meta: {
            title: 'sales_by_modifier',
            breadcrumb: [{ name: 'reports' },
            { name: 'sales_by_modifier' }
            ]
          },
        },
        {
          path: 'sales_discounts',
          component: () => import('@/views/reports/Discount'),
          meta: {
            title: 'discounts',
            breadcrumb: [{ name: 'reports' },
            { name: 'discounts' }
            ]
          },
        },
        {
          path: 'sales_taxes',
          component: () => import('@/views/reports/Taxes'),
          meta: {
            title: 'taxes',
            breadcrumb: [{ name: 'reports' },
            { name: 'taxes' }
            ]
          },
        },
        {
          path: 'sales_item',
          component: () => import('@/views/reports/Item'),
          meta: {
            title: 'sales_by_item',
            breadcrumb: [{ name: 'reports' },
            { name: 'sales_by_item' }
            ]
          },
        },
        {
          path: 'help',
          component: () => import('@/views/help/Help'),
          meta: {
            title: 'help',
            breadcrumb: [{ name: 'help' }]
          }
        }
      ]
    },
    {
      path: '/login',
      component: () => import('@/views/ootb/Login'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/register',
      component: () => import('@/views/ootb/Register'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/forgot-password',
      component: () => import('@/views/ootb/ForgotPassword'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '*',
      component: () => import('@/views/system/NotFound')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === 'SettingTab' && to.query && to.query.store_id) {
    next()
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (localStorage.getItem('access_token') == null) {
        if (to.path == '/purchase-order') {
          next();
        } else {
          next({
            path: '/login',
            params: { nextUrl: to.fullPath }
          })
        }
      } else {
        next()
      }
    } else {
      if (to.path == '/login') {
        if (localStorage.getItem('access_token') != null) {
          next({
            path: '/sales-summary',
            params: { nextUrl: to.fullPath }
          })
        } else {
          next()
        }
      } else {
        next()
      }
    }
  }
})

export default router
